// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import './icons'
import '@/styles/index.scss' // global css
import '@/styles/element-variables.scss'
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
import './plugins/axios.js'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '../node_modules/swiper/dist/css/swiper.css'
import firstInViewPortMove from './directive/firstInViewPort/move.js'
import firstInViewPortScale from './directive/firstInViewPort/scale.js'
Vue.use(VueAwesomeSwiper)
Vue.use(VueDirectiveImagePreviewer)
Vue.use(ElementUI)

Vue.directive('system-first-in-move', firstInViewPortMove)
Vue.directive('system-first-in-scale', firstInViewPortScale)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  mounted () {
    // document.dispatchEvent(new Event('render-event'))
  }
})

router.beforeEach((to, from, next) => {
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})



// WEBPACK FOOTER //
// ./src/main.js